<template>
  <div class="p-2">
    <h4>
      Total: {{ filteredData.length }}
      {{ type === "clients" ? "client" : "prospect"
      }}{{ filteredData.length > 1 ? "s" : "" }}.
    </h4>
    <div class="mt-2">
      <div v-for="status of getActualStatusGroups" :key="status.value">
        <div v-if="status.count > 0" :style="getStatusStyle(status.value)">
          {{ status.label }}: {{ status.count }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ClientProspectStatusList",

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      clientStatus: "getClientStatus",
      prospectStatus: "getProspectStatus",
    }),

    filteredData() {
      return this.data || [];
    },

    availableStatuses() {
      return this.type === "clients" ? this.clientStatus : this.prospectStatus;
    },

    getActualStatusGroups() {
      const statusGroups = {};

      this.filteredData.forEach((item) => {
        const status =
          this.type === "clients" ? item.status : item.prospect?.type;

        if (!statusGroups[status]) {
          statusGroups[status] = {
            value: status,
            label: this.getStatusLabel(status),
            color: this.getStatusColor(status),
            count: 0,
          };
        }

        statusGroups[status].count++;
      });

      return Object.values(statusGroups);
    },
  },

  methods: {
    getStatusLabel(status) {
      const statusObj = this.availableStatuses.find((s) => s.value === status);

      return statusObj ? statusObj.label : status;
    },

    getStatusColor(status) {
      const statusObj = this.availableStatuses.find((s) => s.value === status);

      return statusObj ? statusObj.color : "#95a5a6";
    },

    getStatusStyle(statusValue) {
      const bgColor = this.getStatusColor(statusValue);

      return {
        padding: ".5rem",
        "padding-left": "1rem",
        "border-radius": "1rem",
        "margin-bottom": ".3rem",
        "margin-top": ".3rem",
        color: "white",
        "background-color": bgColor,
      };
    },
  },
};
</script>
